import { useQuery } from '@tanstack/react-query'
import { getFileDownloadUrl } from '../api/data-connectors/get-file-download-url'

/**
 * Fetches a presigned URL for the original uploaded file (e.g. PDF preview).
 */
export function useGetFileDownloadUrl(fileId: string, enabled: boolean) {
  return useQuery({
    queryKey: ['file-download-url', fileId],
    queryFn: () => getFileDownloadUrl(fileId),
    enabled,
    staleTime: 900_000, // 15 minutes as per download url expiration time
  })
}
